import qrcode from "qrcode-generator";

/**
 * Turn a string into an SVG path covering the code's dark modules, in module
 * coordinates. Kept apart from the component so the geometry can be tested
 * without a DOM — a QR code that renders but doesn't scan looks fine on screen,
 * so the grid mapping is worth pinning down.
 */
export function qrPath(
  value: string,
  margin = 2,
): { path: string; extent: number; count: number } {
  // Type number 0 = pick the smallest version that fits; "M" error correction
  // is the usual choice for a printed/on-screen code of this size.
  const qr = qrcode(0, "M");
  qr.addData(value);
  qr.make();

  const count = qr.getModuleCount();
  let path = "";
  for (let row = 0; row < count; row++) {
    for (let col = 0; col < count; col++) {
      if (qr.isDark(row, col)) path += `M${col + margin} ${row + margin}h1v1h-1z`;
    }
  }
  return { path, extent: count + margin * 2, count };
}
